// extracted by mini-css-extract-plugin
export default {"headerNavWrapper":"Navigation_headerNavWrapper__PqfTH"};